import { AppComponent } from './app.component';
import { CsvVersionComponent } from './pages/csv-version/csv-version.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
const routes: Routes = [
  {
    path: '',
    redirectTo: 'de/DE/vehicle-types',
    pathMatch: 'full',
  },
  {
    path: 'csv-version',
    component: CsvVersionComponent,
  },
  {
    path: ':lang/error',
    component: AppComponent,
    loadChildren: () =>
      import('./pages/pages.module').then((m) => m.PagesModule),
  },
  {
    path: ':lang/:country',
    component: AppComponent,
    loadChildren: () =>
      import('./configurator/configurator.module').then(
        (m) => m.ConfiguratorModule
      ),
  },
  {
    path: '**',
    redirectTo: 'error/404',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
